@import "~/styles/v1/_variables.scss";
@import "~/styles/v1/_spacing.scss";

.FlyoverHeader {
  border-bottom: $border-standard;
}

.Tab {
  &_active {
    text-decoration: underline;
  }
}
